import { UserProfileDTO } from '@/api/auth';
import { getAdminTypePriority, RoleIds } from '@/types/administrator';

/**
 * Returns the profiles a user can actually choose between: only profiles for
 * known tenants, excluding impersonation/expired profiles, de-duplicated per
 * organization (highest privileged role wins) and sorted so org admins come
 * first. This mirrors what the ProfilePicker renders as selectable options.
 */
export const getSelectableUserProfiles = (
  profiles: UserProfileDTO[],
  tenants: { id: string }[],
  roleIds: RoleIds,
): UserProfileDTO[] =>
  profiles
    .filter((profile) =>
      tenants.some((tenant) => tenant.id === profile.tenant_id),
    )
    .filter((profile) => !profile.expires_at)
    .sort(
      (a, b) =>
        getAdminTypePriority(roleIds, b.role_id) -
        getAdminTypePriority(roleIds, a.role_id),
    )
    .reduce<UserProfileDTO[]>((acc, profile) => {
      if (
        profile.organization_id &&
        acc.find(
          (existing) => existing.organization_id === profile.organization_id,
        )
      ) {
        return acc;
      }
      return [...acc, profile];
    }, []);
